import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutAlignTopBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutAlignTopBottom"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 15.5V17H17V15.5H7ZM7 8.5H17V7H7V8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutAlignTopBottom;
